import { SyncDirections } from "../../types/integrations/IntegrationRaw";

enum IntegrationSyncDirection {
  SERVICE_TO_MMC = "serviceToMmc",
  MMC_TO_SERVICE = "mmcToService",
  BOTH_DIRECTIONS = "bothDirections",
}

export const getSyncDirection = (
  syncDirection: SyncDirections | undefined = {
    incoming: true,
    outgoing: false,
  }
) => {
  if (syncDirection?.incoming && syncDirection?.outgoing) {
    return IntegrationSyncDirection.BOTH_DIRECTIONS;
  } else if (syncDirection?.outgoing) {
    return IntegrationSyncDirection.MMC_TO_SERVICE;
  }
  return IntegrationSyncDirection.SERVICE_TO_MMC;
};

export default IntegrationSyncDirection;
